/**
 * All configurators. Each single-product configurator is driven by the
 * catalogue in product/model.ts; the gift set has its own flow. Adding a new
 * cylindrical product = containers in the catalogue + a dictionary entry.
 */
import type { ProductKind } from '@shared/rfq';

export interface ConfiguratorEntry {
  kind: ProductKind;
  route: string;
}

export const CONFIGURATORS: ConfiguratorEntry[] = [
  { kind: 'candle', route: '/configurator/candle' },
  { kind: 'diffuser', route: '/configurator/diffuser' },
  { kind: 'bottle', route: '/configurator/bottle' },
  { kind: 'cosmetic', route: '/configurator/cosmetic' },
  { kind: 'drinkware', route: '/configurator/drinkware' },
  { kind: 'gift', route: '/configurator/gift' },
];

export function routeFor(kind: ProductKind): string {
  return CONFIGURATORS.find((c) => c.kind === kind)?.route ?? '/configurator/candle';
}

/** Old routes that moved (ceramic mugs were replaced by drinkware). */
const ALIASES: Record<string, ProductKind> = { mug: 'drinkware' };

export function kindForPath(path: string): ProductKind | null {
  const m = /^\/configurator\/([a-z]+)\/?$/.exec(path);
  const k = m?.[1] && ALIASES[m[1]] ? ALIASES[m[1]] : m?.[1];
  return CONFIGURATORS.some((c) => c.kind === k) ? (k as ProductKind) : null;
}
